// This file is auto-generated by localize-js, do not make edits to this file directly
import { TranslatedStringTableFetcher, getStringProvider } from '@fluidx/localize-js';

export interface HostUxStrings {
  /**
  * The error dialog title when user is not authorized
  *
  * @defaultValue "Make sure you're signed in"
  */
  authorizationErrorTitle: string;
  /**
  * The error dialog message when user is not authorized
  *
  * @defaultValue "It seems like you don’t have access to this. Check that you’re signed in, then reload the page. If that doesn’t work, make sure the owner has given you access."
  */
  authorizationErrorMessage: string;
  /**
  * Leading, emphasized text in error banner when user is not authorized
  *
  * @defaultValue "Couldn't Open This"
  */
  authorizationErrorBannerTitle: string;
  /**
  * The error banner message when user is not authorized
  *
  * @defaultValue "Make sure you’re signed in and that the owner has given you access, then try again."
  */
  authorizationErrorBannerMessage: string;
  /**
  * The string used in the overflow menu header
  *
  * @defaultValue "{count, number} other people are here"
  */
  coauthorGalleryOverflowMenuHeader: (placeholders: { count: number; }) => string;
  /**
  * Within the error dialog, the text for close button
  *
  * @defaultValue "Close"
  */
  close: string;
  /**
  * String that appears in the coauthor gallery when the user is editing
  *
  * @defaultValue "Has this file open"
  */
  editingStatus: string;
  /**
  * Title for the Error Boundary Dialog
  *
  * @defaultValue "Error Boundary"
  */
  errorBoundary: string;
  /**
  * Title of the error dialog
  *
  * @defaultValue "Reload to continue"
  */
  errorDialogTitle: string;
  /**
  * Leading, emphasized text in banner when there is a critical error raised
  *
  * @defaultValue "Please Reload"
  */
  criticalErrorBannerTitle: string;
  /**
  * The banner message when there is a critical error raised
  *
  * @defaultValue "We're sorry, but something happened. If you've made any changes, they might not have saved."
  */
  criticalErrorBannerMessage: string;
  /**
  * Error Dialog Title for File Not Found or Access Denied dialog
  *
  * @defaultValue "The file isn't available anymore"
  */
  fileNotFoundOrAccessDeniedTitle: string;
  /**
  * Error Dialog Text for File Not Found or Access Denied dialog
  *
  * @defaultValue "This file may have been moved or deleted, or you may not have access to it."
  */
  fileNotFoundOrAccessDeniedMessage: string;
  /**
  * Leading, emphasized text in banner when file has been moved, deleted or user no longer has access
  *
  * @defaultValue "Not Available"
  */
  fileNotFoundOrAccessDeniedBannerTitle: string;
  /**
  * The banner message when file has been moved, deleted or user no longer has access
  *
  * @defaultValue "This component may have been moved or deleted, or you may not have access."
  */
  fileNotFoundOrAccessDeniedBannerMessage: string;
  /**
  * Error Dialog Title for Component Not Found dialog
  *
  * @defaultValue "Component not available"
  */
  componentNotFoundTitle: string;
  /**
  * Error Dialog Text for Component Not Found dialog
  *
  * @defaultValue "We couldn't find the requested component; it may have been deleted."
  */
  componentNotFoundMessage: string;
  /**
  * Error Dialog Title for Container Upgrade Required dialog
  *
  * @defaultValue "Get the latest version"
  */
  containerUpgradeRequiredTitle: string;
  /**
  * Error Dialog Text for Container Upgrade Required dialog
  *
  * @defaultValue "There's a new version of this preview. To get it, please reload."
  */
  containerUpgradeRequiredMessage: string;
  /**
  * Leading, emphasized text in banner when container upgrade is required
  *
  * @defaultValue "New Version"
  */
  containerUpgradeRequiredBannerTitle: string;
  /**
  * The banner message when container upgrade is required
  *
  * @defaultValue "There's a new version ready. Reload to continue."
  */
  containerUpgradeRequiredBannerMessage: string;
  /**
  * Error Dialog Title when an unexpected error occurs
  *
  * @defaultValue "Reload to continue"
  */
  genericErrorDialogTitle: string;
  /**
  * A generic user friendly error message
  *
  * @defaultValue "We're sorry, but something happened and you need to reload to continue. If you've made any changes, they might not have saved."
  */
  genericErrorMessage: string;
  /**
  * Title of the error dialog when service is busy
  *
  * @defaultValue "Try again later"
  */
  genericServiceBusyDialogTitle: string;
  /**
  * Text within the error dialog when the service is busy
  *
  * @defaultValue "The server is too busy to work on this right now. Please reload or try again later."
  */
  genericServiceBusyMessage: string;
  /**
  * Leading, emphasized text in banner when service is busy
  *
  * @defaultValue "Try Again"
  */
  genericServiceBusyBannerTitle: string;
  /**
  * The banner message when service is busy
  *
  * @defaultValue "Please reload or check back later."
  */
  genericServiceBusyBannerMessage: string;
  /**
  * Within the error dialog, string for the Give Feedback button
  *
  * @defaultValue "Give feedback"
  */
  giveFeedback: string;
  /**
  * String that appears in the coauthor gallery when the user is away
  *
  * @defaultValue "Away"
  */
  inactiveStatus: string;
  /**
  * Leading, emphasized text in banner when container is disconnected
  *
  * @defaultValue "Reconnecting..."
  */
  disconnectedStateBannerTitle: string;
  /**
  * The banner message when container is disconnected
  *
  * @defaultValue "You can keep working but your recent changes may not save."
  */
  disconnectedStateBannerMessage: string;
  /**
  * Leading, emphasized text in banner when the container is readonly
  *
  * @defaultValue "Read Only"
  */
  readonlyStateBannerTitle: string;
  /**
  * The banner message when the container is readonly
  *
  * @defaultValue "You can view this, but can't edit"
  */
  readonlyStateBannerMessage: string;
  /**
  * The banner message when the container is readonly and you are on a mobile device
  *
  * @defaultValue "To edit, view on a computer"
  */
  readonlyStateMobileBannerMessage: string;
  /**
  * Leading, emphasized text in banner when ODSP file has been restored
  *
  * @defaultValue "Not In Sync"
  */
  odspVersionMismatchBannerTitle: string;
  /**
  * The banner message when ODSP file has been restored
  *
  * @defaultValue "Copy any changes you’ve made, reload, then paste your changes."
  */
  odspVersionMismatchBannerMessage: string;
  /**
  * Title when ODSP file storage is full
  *
  * @defaultValue "Out of Storage"
  */
  odspOutOfStorageDialogTitle: string;
  /**
  * Text within the error dialog when ODSP file storage is full
  *
  * @defaultValue "Please delete some files from this location and then try again."
  */
  odspOutOfStorageMessage: string;
  /**
  * Leading, emphasized text in banner when ODSP file storage is full
  *
  * @defaultValue "Out of Storage"
  */
  odspOutOfStorageBannerTitle: string;
  /**
  * The banner message when ODSP file storage is full
  *
  * @defaultValue "Please delete some files from this location"
  */
  odspOutOfStorageBannerMessage: string;
  /**
  * The text that appears when hovering over the navigate to file location button
  *
  * @defaultValue "Go to file location"
  */
  navigateToFileLocationTitle: string;
  /**
  * Text for button that opens file storage location on out of storage banner
  *
  * @defaultValue "View location"
  */
  viewFileLocationButtonText: string;
  /**
  * The text that appears when hovering over the open in office.com button
  *
  * @defaultValue "Open in Office.com"
  */
  openInOffice: string;
  /**
  * The label for the button that appears in the top left of the app to signify that it is a preview experience
  *
  * @defaultValue "Preview"
  */
  previewButtonLabel: string;
  /**
  * The title for the dialog that appears when clicking the preview button
  *
  * @defaultValue "About this preview"
  */
  previewLabelDialogTitle: string;
  /**
  * The title for the dialog that appears when clicking the preview button within the context of consumer users
  *
  * @defaultValue "Get ready to collaborate"
  */
  previewLabelDialogTitleConsumer: string;
  /**
  * The first content para for the dialog that appears when clicking the preview button
  *
  * @defaultValue "This preview provides limited support for enterprise scenarios, like search/discovery, retention, and classification. As a preview, features and functionality may change at any time."
  */
  previewLabelDialogFirstPara: string;
  /**
  * The first content para for the dialog that appears when clicking the preview button within context of Consumer user
  *
  * @defaultValue "We’re excited for you to try this preview because it’s perfect for fast collaboration. Create an action item table, checklist, or other component, then share with others. Everyone can work together at the same time and you’ll see everyone’s edits as they’re typed. Their changes will be reflected anywhere that component is shared, so everything stays up-to-date with no extra management from you."
  */
  previewLabelDialogFirstParaConsumer: string;
  /**
  * The second content para for the dialog that appears when clicking the preview button within context of Consumer user
  *
  * @defaultValue "As a preview, features and functionality may change at any time, however no matter if things in the preview change, your data and info is secure and private.​"
  */
  previewLabelDialogSecondParaConsumer: string;
  /**
  * The text for getting started guid link shown in the dialog that appears when clicking the preview button
  *
  * @defaultValue "Learn more"
  */
  previewLabelDialogGettingStartedLinkText: string;
  /**
  * The text for the terms of use link shown in the dialog that appears when clicking the preview button
  *
  * @defaultValue "Microsoft Online Service Terms"
  */
  previewLabelDialogTermsLinkText: string;
  /**
  * The text for the privacy and cookies link shown in the dialog that appears when clicking the preview button
  *
  * @defaultValue "Privacy & Cookies"
  */
  previewLabelDialogPrivacyLinkText: string;
  /**
  * The text for the third party notices link shown in the dialog that appears when clicking the preview button
  *
  * @defaultValue "Third-Party Notices"
  */
  previewLabelDialogThirdPartyLinkText: string;
  /**
  * The text for the button that appears in the dialog when clicking the preview button
  *
  * @defaultValue "Got it"
  */
  previewLabelDialogConfirmButtonText: string;
  /**
  * Text for Authorize button
  *
  * @defaultValue "Authorize"
  */
  authorizeButtonText: string;
  /**
  * Text for Reload button
  *
  * @defaultValue "Reload"
  */
  reloadButtonText: string;
  /**
  * Text for Upgrade button
  *
  * @defaultValue "Upgrade"
  */
  upgradeButtonText: string;
  /**
  * The user action when the unexpected error dialog pops up
  *
  * @defaultValue "Please try opening the document again."
  */
  retryOpeningDocument: string;
  /**
  * The text of the share button
  *
  * @defaultValue "Share"
  */
  shareButtonText: string;
  /**
  * Sharing error message
  *
  * @defaultValue "Sorry, we are unable to reach the server right now. Please try again later."
  */
  shareDialogErrorMessage: string;
  /**
  * Error title for share dialog in share mode
  *
  * @defaultValue "Failed to share"
  */
  shareDialogErrorTitle: string;
  /**
  * Error title for share dialog in copy mode
  *
  * @defaultValue "Failed to copy"
  */
  copyDialogErrorTitle: string;
  /**
  * Fallback in cases where company name is missing for share
  *
  * @defaultValue "your company"
  */
  shareFallbackCompanyName: string;
  /**
  * Text read out by screen readers informing users they have reached a collaborative component hosting UX
  *
  * @defaultValue "Live component. Press Enter for component controls."
  */
  componentUXWrapperAriaLabel: string;
  /**
  * Text read out by screen readers informing users they have reached a collaborative component hosting UX and the component is still loading
  *
  * @defaultValue "Loading live component. Press Enter for component controls."
  */
  componentUXWrapperLoadingAriaLabel: string;
  /**
  * Text read out by screen readers informing users they have reached a collaborative component
  *
  * @defaultValue "Live component"
  */
  componentAriaLabel: string;
  /**
  * Text read out by screen readers instructing users on how to interact with a focusable collaborative component
  *
  * @defaultValue "Live component. Press Enter to interact with component."
  */
  focusableComponentAriaLabel: string;
  /**
  * The text for button to expand action menu
  *
  * @defaultValue "More actions"
  */
  actionMenuOverflowButtonTitle: string;
  /**
  * {authorName} is a string representing a name of a person. {relativeTimestamp} is a system-localized time string such '3m ago' or 'yesterday at 12:30 PM' representing a relative time format.
  *
  * @defaultValue "{authorName} edited {relativeTimestamp}"
  */
  lastEditedTooltipText: (placeholders: { authorName: string; relativeTimestamp: string; }) => string;
  /**
  * {relativeTimestamp} is a system-localized time string such '3m ago' or 'yesterday at 12:30 PM' representing a relative time format. {authorName} is a string representing a name of a person.
  *
  * @defaultValue "Edited {relativeTimestamp} by {authorName}"
  */
  lastEditedAriaLabelText: (placeholders: { relativeTimestamp: string; authorName: string; }) => string;
  /**
  * Describes when a recent event occurred, within the last two minutes.
  *
  * @defaultValue "Just now"
  */
  relativeTimestampJustNow: string;
  /**
  * Describes when a recent event occurred by the author, within the last two minutes. {authorName} is a string representing a name of a person.
  *
  * @defaultValue "{authorName} edited just now"
  */
  relativeTimestampJustNowWithAuthorTooltipText: (placeholders: { authorName: string; }) => string;
  /**
  * Describes when a recent event occurred by the author, within the last two minutes. {authorName} is a string representing a name of a person.
  *
  * @defaultValue "Edited just now by {authorName}"
  */
  relativeTimestampJustNowWithAuthorAriaLabel: (placeholders: { authorName: string; }) => string;
  /**
  * Describes when a recent event occurred by the author, {minutes, number} is a number such as '11'. 'm' is a short form representational string for 'minutes'(CLDR logic minute-short). This string refers to some time minutes ago. {authorName} is a string representing a name of a person.
  *
  * @defaultValue "{authorName} edited {minutes, number}m ago"
  */
  relativeTimestampMinutesAgoWithAuthorTooltipText: (placeholders: { authorName: string; minutes: number; }) => string;
  /**
  * Describes when a recent event occurred by the author, {minutes, number} is a number such as '11'. 'm' is a short form representational string for 'minutes'(CLDR logic minute-short). This string refers to some time minutes ago. {authorName} is a string representing a name of a person.
  *
  * @defaultValue "Edited {minutes, number} minutes ago by {authorName}"
  */
  relativeTimestampMinutesAgoWithAuthorAriaLabel: (placeholders: { minutes: number; authorName: string; }) => string;
  /**
  * {hours, number} is a number such as '11'. 'h' is a short form representational string for 'hours'(CLDR logic hour-short). This string refers to some time hours ago. {authorName} is a string representing a name of a person.
  *
  * @defaultValue "{authorName} edited {hours, number}h ago"
  */
  relativeTimestampHoursAgoWithAuthorTooltipText: (placeholders: { authorName: string; hours: number; }) => string;
  /**
  * {hours, number} is a number such as '11'. This string refers to some time hours ago. {authorName} is a string representing a name of a person.
  *
  * @defaultValue "Edited {hours, number} hours ago by {authorName}"
  */
  relativeTimestampHoursAgoWithAuthorAriaLabel: (placeholders: { hours: number; authorName: string; }) => string;
  /**
  * {time} is a system-localized time string such as '11:59 PM'. This string refers generally to some time yesterday (before last midnight). {authorName} is a string representing a name of a person.
  *
  * @defaultValue "{authorName} edited yesterday at {time}"
  */
  relativeTimestampYesterdayWithAuthorTooltipText: (placeholders: { authorName: string; time: string; }) => string;
  /**
  * {time} is a system-localized time string such as '11:59 PM'. This string refers generally to some time yesterday (before last midnight). {authorName} is a string representing a name of a person.
  *
  * @defaultValue "Edited yesterday at {time} by {authorName}"
  */
  relativeTimestampYesterdayWithAuthorAriaLabel: (placeholders: { time: string; authorName: string; }) => string;
  /**
  * {day} is a system-localized date string such as 'Wed' or 'Jan 4'. 'Wed' or 'Jan 4' is a short form representational string for 'day'(CLDR logic day-short). {time} is a system-localized time string such as '4:22 PM'. {authorName} is a string representing a name of a person.
  *
  * @defaultValue "{authorName} edited on {day} at {time}"
  */
  relativeTimestampWithinLastDaysWithAuthorTooltipText: (placeholders: { authorName: string; day: string; time: string; }) => string;
  /**
  * {day} is a system-localized date string such as 'Wed' or 'Jan 4'. 'Wed' or 'Jan 4' is a short form representational string for 'day'(CLDR logic day-short). {time} is a system-localized time string such as '4:22 PM'. {authorName} is a string representing a name of a person.
  *
  * @defaultValue "Edited on {day} at {time} by {authorName}"
  */
  relativeTimestampWithinLastDayWithAuthorAriaLabel: (placeholders: { day: string; time: string; authorName: string; }) => string;
  /**
  * {date} is a system-localized date string such as 'Jan 4', 'Jan 4 2019'. 'Jan 4', 'Jan 4 2019' is a short form representational string for date. {authorName} is a string representing a name of a person.
  *
  * @defaultValue "{authorName} edited on {date}"
  */
  relativeTimestampGenericWithAuthorTooltipText: (placeholders: { authorName: string; date: string; }) => string;
  /**
  * {date} is a system-localized date string such as 'Jan 4', 'Jan 4 2019'. 'Jan 4', 'Jan 4 2019' is a short form representational string for date. {authorName} is a string representing a name of a person.
  *
  * @defaultValue "Edited on {date} by {authorName}"
  */
  relativeTimestampGenericWithAuthorAriaLabel: (placeholders: { date: string; authorName: string; }) => string;
  /**
  * Describes when a recent event occurred, within the last two minutes.
  *
  * @defaultValue "just now"
  */
  relativeTimestampJustNowLowerCase: string;
  /**
  * {minutes, number} is a number such as '11'. 'm' is a short form representational string for 'minutes'(CLDR logic minute-short). This string refers to some time minutes ago.
  *
  * @defaultValue "{minutes, number}m ago"
  */
  relativeTimestampMinutesAgo: (placeholders: { minutes: number; }) => string;
  /**
  * {minutes, number} is a number such as '11'. This string refers to some time minutes ago.
  *
  * @defaultValue "{minutes, number} minutes ago"
  */
  relativeTimestampMinutesAgoFull: (placeholders: { minutes: number; }) => string;
  /**
  * {hours, number} is a number such as '11'. 'h' is a short form representational string for 'hours'(CLDR logic hour-short). This string refers to some time hours ago.
  *
  * @defaultValue "{hours, number}h ago"
  */
  relativeTimestampHoursAgo: (placeholders: { hours: number; }) => string;
  /**
  * {hours, number} is a number such as '11'. This string refers to some time hours ago.
  *
  * @defaultValue "{hours, number} hours ago"
  */
  relativeTimestampHoursAgoFull: (placeholders: { hours: number; }) => string;
  /**
  * {time} is a system-localized time string such as '11:59 PM'. This string refers generally to some time yesterday (before last midnight).
  *
  * @defaultValue "Yesterday at {time}"
  */
  relativeTimestampYesterday: (placeholders: { time: string; }) => string;
  /**
  * {time} is a system-localized time string such as '11:59 PM'. This string refers generally to some time yesterday (before last midnight).
  *
  * @defaultValue "yesterday at {time}"
  */
  relativeTimestampYesterdayLowerCase: (placeholders: { time: string; }) => string;
  /**
  * {day} is a system-localized date string such as 'Wed' or 'Jan 4'. 'Wed' or 'Jan 4' is a short form representational string for 'day'(CLDR logic day-short). {time} is a system-localized time string such as '4:22 PM'.
  *
  * @defaultValue "{day} at {time}"
  */
  relativeTimestampWithinLastDays: (placeholders: { day: string; time: string; }) => string;
  /**
  * Text that appears when you hover over permissionsPanel entrypoint in ComponentUX. Also used by screen readers.
  *
  * @defaultValue "See who has access"
  */
  permissionsEntrypointTitle: string;
  /**
  * Title of the Permissions Panel that renders when you click on permissionsPanel entrypoint in ComponentUX.
  *
  * @defaultValue "Collaboration"
  */
  permissionsPanelTitle: string;
  /**
  * {number} is a count of links such as 2. When there is more than one share link associated with a components file.
  *
  * @defaultValue "{count, number} links giving access"
  */
  permissionsPanelMultipleShareLinks: (placeholders: { count: number; }) => string;
  /**
  * Text for toggle menu button
  *
  * @defaultValue "More"
  */
  commandingSurfaceToggleBtnText: string;
  /**
  * {number} is a count of groups such as 2. When there are more than one groups that have access to file.
  *
  * @defaultValue "{count, number} groups giving access"
  */
  permissionsPanelGroupsTooltip: (placeholders: { count: number; }) => string;
  /**
  * This text would be shown when there is exact match between people participating and people who have permissions.
  *
  * @defaultValue "People in this chat have access"
  */
  permissionsPanelSpecificPermissionText: string;
  /**
  * Text for copy link button in permissions panel.
  *
  * @defaultValue "Copy"
  */
  copyLinkText: string;
  /**
  * Text to describe share link displayed in Permissions panel
  *
  * @defaultValue "People in your organization with the link can edit"
  */
  organizationWideEditLinkDescription: string;
  /**
  * Text to describe share link displayed in Permissions panel
  *
  * @defaultValue "People in your organization with the link can view"
  */
  organizationWideViewLinkDescription: string;
  /**
  * Text to describe share link displayed in Permissions panel
  *
  * @defaultValue "Anyone with the link can edit"
  */
  anonymousEditLinkDescription: string;
  /**
  * Text to describe share link displayed in Permissions panel
  *
  * @defaultValue "Anyone with the link can view"
  */
  anonymousViewLinkDescription: string;
  /**
  * Text to describe share link displayed in Permissions panel
  *
  * @defaultValue "Specific people with the link can edit"
  */
  specificUsersEditLinkDescription: string;
  /**
  * Text to describe share link displayed in Permissions panel
  *
  * @defaultValue "Specific people with the link can view"
  */
  specificUsersViewLinkDescription: string;
  /**
  * Text read out by screen readers informing about list
  *
  * @defaultValue "List of people who have access"
  */
  permissionsPanelFacepileAriaLabel: string;
  /**
  * Text read out by screen readers informing about how many more people are listed in overflow menu
  *
  * @defaultValue "{count, number} more people"
  */
  permissionsPanelOverflowButtonAriaLabel: (placeholders: { count: number; }) => string;
  /**
  * Text to describe share link displayed in Permissions panel
  *
  * @defaultValue "People outside this chat with the link have access"
  */
  permissionsPanelPeopleOutsideWithLinkText: string;
  /**
  * Title of the version banner when previous version is loaded
  *
  * @defaultValue "Previous Version"
  */
  versionBannerTitle: string;
  /**
  * Message of previous version banner
  *
  * @defaultValue "You can copy content from this version"
  */
  versionBannerMessage: string;
  /**
  * This text would be shown when there is no share link and when less people that in the roster have access.
  *
  * @defaultValue "Some people in this chat have access"
  */
  permissionsPanelSomePeopleText: string;
  /**
  * This text would be shown when there is no share link and when more people than in the roster have access.
  *
  * @defaultValue "People outside this chat have access"
  */
  permissionsPanelPeopleOutsideText: string;
  /**
  * This text would be shown when there is no share link and when there is no roster present.
  *
  * @defaultValue "These people have access"
  */
  permissionsPanelSpecificPeopleText: string;
  /**
  * {userName} is a string representing a name of a person. Text for the button that allows a user to follow another user.
  *
  * @defaultValue "Follow {userName}"
  */
  followButtonText: (placeholders: { userName: string; }) => string;
  /**
  * {userName} is a string representing a name of a person. Text for the button that allows a user to stop following another user.
  *
  * @defaultValue "Stop Following {userName}"
  */
  followExitButtonText: (placeholders: { userName: string; }) => string;
}

export async function getHostUxStrings(translatedStringTableFetcher: TranslatedStringTableFetcher, locale: string): Promise<HostUxStrings> {
  const stringTableJson = await translatedStringTableFetcher(locale);
  return getStringProvider<HostUxStrings>(stringTableJson, locale);
}
